import React, { useState } from "react";
import { Mail, MapPin, Clock } from "lucide-react";
import { MoonMark as Moon } from "@/components/MoonMark";
import { toast } from "sonner";
import { api } from "@/lib/api";
import MoonDivider from "@/components/MoonDivider";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Your whisper has been received. We'll be in touch.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const field = "w-full bg-noir-2 border border-white/15 px-4 py-3 font-body text-cream placeholder:text-white/30 focus:border-gold focus:outline-none transition-colors";

  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="contact-page">
      <div className="text-center mb-4">
        <Moon className="w-7 h-7 text-gold mx-auto mb-4" strokeWidth={1.2} />
        <p className="font-body uppercase tracking-[0.35em] text-xs text-gold mb-3">Whisper To Us</p>
        <h1 className="font-serif text-5xl sm:text-6xl text-cream">Contact</h1>
      </div>
      <MoonDivider />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-12">
        <div className="space-y-8">
          <p className="font-body text-white/60 leading-relaxed">
            Have a question, a special request, or a confession? We're here for you — discreetly, of course.
          </p>
          <div className="space-y-5 font-body text-sm">
            <div className="flex items-start gap-4">
              <Mail className="w-5 h-5 text-gold mt-0.5" strokeWidth={1.5} />
              <div><p className="text-cream">Email</p><p className="text-white/50">info@afterdarkchoc.com</p></div>
            </div>
            <div className="flex items-start gap-4">
              <MapPin className="w-5 h-5 text-gold mt-0.5" strokeWidth={1.5} />
              <div><p className="text-cream">Workshop</p><p className="text-white/50">Shipping worldwide from our discreet chocolate workshop</p></div>
            </div>
            <div className="flex items-start gap-4">
              <Clock className="w-5 h-5 text-gold mt-0.5" strokeWidth={1.5} />
              <div><p className="text-cream">After Hours</p><p className="text-white/50">We reply within one business day</p></div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <input required placeholder="Your name" value={form.name} data-testid="contact-name"
            onChange={(e) => setForm({ ...form, name: e.target.value })} className={field} />
          <input required type="email" placeholder="Your email" value={form.email} data-testid="contact-email"
            onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} />
          <textarea required rows={5} placeholder="Your message" value={form.message} data-testid="contact-message"
            onChange={(e) => setForm({ ...form, message: e.target.value })} className={field} />
          <button type="submit" disabled={sending} data-testid="contact-submit"
            className="w-full py-4 bg-gold text-black font-body uppercase tracking-[0.2em] text-xs hover:bg-champagne transition-colors disabled:opacity-50">
            {sending ? "Sending…" : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
